import * as api from './api';

const TABLE = 'category';
const PK = 'category_id';

export const fetchCategories = (searchTerm = '') =>
  api.fetchRecords(TABLE, {
    searchField: 'category_name',
    searchTerm,
  });

export const createCategory = (data) => {
  const { [PK]: _id, ...payload } = data;   // strip auto-increment PK
  return api.createRecord(TABLE, payload);
};

export const updateCategory = (id, data) =>
  api.updateRecord(TABLE, PK, id, data);

export const deleteCategory = (id) =>
  api.deleteRecord(TABLE, PK, id);
